<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Invoice</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.status" :options="optFilterStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Customer">
                        <multiselect v-model="filter.customer"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optCustomer"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="Tgl. Penjualan Dari">
                        <b-form-input type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Tgl. Penjualan Sampai">
                        <b-form-input type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button class="ml-2" variant="dark" @click="calculateTotal()">
                            <i class="fa fa-calculator mr-2" />Total
                        </b-button>
                        <b-button class="ml-2" variant="dark" @click="calculateTotalReturn()">
                            <i class="fa fa-calculator mr-2" />Total Retur
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" class="ml-2" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Invoice Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data invoice.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    {{ row.item.no_faktur || "--DRAFT--" }}
                    <div class="small text-muted">
                        {{ row.item.no_ref || "-" }}<br />
                        <strong>{{ row.item.customer_name }}</strong>
                    </div>
                </template>
                <template v-slot:cell(sold_at)="row">
                    {{ $helper.parseDate(row.item.sold_at) }}
                    <div class="small text-muted">
                        {{ row.item.created_by }} - {{ $helper.parseDate(row.item.created) }}, {{ $helper.parseHourMinute(row.item.created) }}
                    </div>
                    <div class="small">
                        {{ row.item.details_count }} unit barang - {{ row.item.division }}
                    </div>
                    <div class="small text-muted">
                        <strong>{{ row.item.warehouse }} - {{ row.item.office }}</strong>
                    </div>
                </template>
                <template v-slot:cell(payment)="row">
                    Rp. {{ $helper.formatThousand(row.item.total) }}
                    <div class="small">
                        Tersisa <strong>Rp. {{ $helper.formatThousand(row.item.outstanding_payment) }}</strong><br />
                        PB terakhir {{ $helper.parseDate(row.item.last_payment) }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{ getStatusBadge(row.item.status)[1] }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link v-if="row.item.status == 1" :to="'invoice/draft/' + row.item.id">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Lanjut Draft">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link v-if="[2, 3].includes(row.item.status)" :to="'invoice/' + row.item.id">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail Invoice">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                    <b-button v-if="[2, 3].includes(row.item.status)" class="ml-2" size="sm" variant="dark" v-b-tooltip.hover.top title="Pembayaran" @click="showPayments(row.item)">
                        <i class="fa fa-fw fa-dollar" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Invoice Baru" centered no-close-on-backdrop hide-footer>
            <b-form-group label="Membuat invoice baru untuk...">
                <multiselect v-model="input.customer"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optCustomer"
                />
            </b-form-group>
            <b-form-group label="Pengambilan dari gudang...">
                <multiselect v-model="input.warehouse"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optWarehouse"
                />
            </b-form-group>
            <b-form-group label="Divisi...">
                <multiselect v-model="input.division"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optDivision"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting || input.customer == null" @click="createInvoice">
                    {{ isSubmitting ? "Membuat..." : "Buat Invoice Baru" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-payments" title="Pembayaran Invoice" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <ModalInvoicePayments :invoiceId="activeItem.id" />
        </b-modal>
        <b-modal id="m-calculate" title="Perhitungan Totalan" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-if="calculateTotalData.customer != null">
                    Customer: <strong>{{ calculateTotalData.customer }}</strong>
                </div>
                <div v-if="calculateTotalData.start != null">
                    Dari Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.start) }}</strong>
                </div>
                <div v-if="calculateTotalData.end != null">
                    Sampai Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.end) }}</strong>
                </div>
                <hr />
                Total Invoice: <strong>{{ calculateTotalData.total_invoices }}</strong> invoice<br />
                Total Barang: <strong>{{ calculateTotalData.total_items }}</strong> barang<br />
                Total Harga: <strong>Rp. {{ $helper.formatThousand(calculateTotalData.total_price) }}</strong>
            </div>
        </b-modal>
        <b-modal id="m-calculate-return" title="Perhitungan Totalan Retur" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-if="calculateTotalData.customer != null">
                    Customer: <strong>{{ calculateTotalData.customer }}</strong>
                </div>
                <div v-if="calculateTotalData.start != null">
                    Dari Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.start) }}</strong>
                </div>
                <div v-if="calculateTotalData.end != null">
                    Sampai Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.end) }}</strong>
                </div>
                <hr />
                Total Invoice: <strong>{{ calculateTotalData.total_invoices }}</strong> invoice<br />
                Total Barang Retur: <strong>{{ calculateTotalData.total_items_return }}</strong> barang<br />
                Total Harga Retur: <strong>Rp. {{ $helper.formatThousand(calculateTotalData.total_price_return) }}</strong>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalInvoicePayments from './ModalInvoicePayments.vue'

export default {
    components: {
        ModalInvoicePayments
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            calculateTotalData: {},

            filter: {
                noFaktur: "",
                status: -1,
                customer: null,
                startDate: "",
                endDate: ""
            },

            input: {
                customer: null,
                warehouse: null,
                division: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "noFaktur", label: "No. Faktur Invoice", sortable: true },
                { key: "sold_at", label: "Tgl. Penjualan", sortable: true },
                { key: "payment", label: "Total & Sisa Pembayaran", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Draft" },
                { value: 2, text: "Ongoing" },
                { value: 3, text: "Lunas" },
                // { value: 0, text: "Void" }
            ],

            optCustomer: [],
            optWarehouse: [],
            optDivision: []

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getCustomers = this.$axios.get("customer/selection").then(res => {
                this.optCustomer = res.data.data
            })

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                this.optWarehouse = res.data.data.map(it => {
                    return { id: it.id, name: it.name + " - " + it.office_name }
                })
            })

            let getDivisions = this.$axios.get("division/get-all-filtered").then(res => {
                this.optDivision = res.data.data
            })

            Promise.all([getItems, getCustomers, getWarehouses, getDivisions]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        createInvoice() {

            if(this.input.customer == null) {
                return this.$helper.toastError(this, "Mohon memilih customer!")
            }

            if(this.input.warehouse == null) {
                return this.$helper.toastError(this, "Mohon memilih gudang!")
            }

            this.isSubmitting = true
            let payload = {
                customer_id: this.input.customer.id,
                warehouse_id: this.input.warehouse.id,
                division_id: this.input.division.id
            }

            this.$axios.post("invoice", payload).then(res => {

                let data = res.data.data
                this.$router.push({ path: "invoice/draft/" + data.id })

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(this.filter.customer != null) {
                param += "&filterCustomer=" + this.filter.customer.id
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("invoice" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listInvoiceFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        calculateTotal() {

            // Cek minimal tanggal terisi atau customer terisi
            let customerFilled = this.filter.customer != null
            let dateFilled = this.filter.startDate != "" || this.filter.endDate != ""

            if(!customerFilled && !dateFilled) {
                return this.$helper.toastError(this, "Mohon mengisi minimal filter customer atau tanggal penjualan!")
            }

            let param = ""

            if(this.filter.customer != null) {
                param += "&filterCustomer=" + this.filter.customer.id
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            this.isSubmitting = true
            this.$bvModal.show("m-calculate")

            this.$axios.get("invoice/calculate?" + param).then(res => {
                this.calculateTotalData = res.data.data
                // sessionStorage.setItem("listInvoiceFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("m-calculate")
            })
            .finally(() => this.isSubmitting = false)

        },

        calculateTotalReturn() {

            // Cek minimal tanggal terisi atau customer terisi
            let customerFilled = this.filter.customer != null
            let dateFilled = this.filter.startDate != "" || this.filter.endDate != ""

            if(!customerFilled && !dateFilled) {
                return this.$helper.toastError(this, "Mohon mengisi minimal filter customer atau tanggal penjualan!")
            }

            let param = ""

            if(this.filter.customer != null) {
                param += "&filterCustomer=" + this.filter.customer.id
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            this.isSubmitting = true
            this.$bvModal.show("m-calculate-return")

            this.$axios.get("invoice/calculate-return?" + param).then(res => {
                this.calculateTotalData = res.data.data
                // sessionStorage.setItem("listInvoiceFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("m-calculate-return")
            })
            .finally(() => this.isSubmitting = false)

        },

        showPayments(item) {
            this.activeItem = item
            this.$bvModal.show("m-payments")
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getStatusBadge(status) {
            switch(status) {
                case 0: return ["danger", "VOID"]
                case 1: return ["dark", "DRAFT"]
                case 2: return ["primary", "ONGOING"]
                case 3: return ["success", "LUNAS"]
                default: return ["light", "-"]
            }
        }

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listInvoiceFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listInvoiceFilter"))
        }
        this.init()
        this.$helper.toastFlash(this)
    }
}
</script>
